<p>reprint-last-ticket works!</p>
